export default __webpack_public_path__ + "static/gabriel-44c983cffd60a13301896d92015b2c50.jpg";